export const isValidHex = (str, useFlexible = false) => {
  let re = useFlexible ? /^#(?:[0-9a-fA-F]{3}){1,2}$/g : /[0-9A-Fa-f]{6}/g;
  return re.test(str) && str.length === 7;
};

// Returns if a value is an object
export const isObject = (value) => {
  return (
    !isNaN(value) &&
    typeof value !== "string" &&
    typeof value === "object" &&
    value?.constructor === Object
  );
};

export const noBlankValues = (arr) => {
  return !arr.reduce((accumulator, el) => {
    return accumulator || el.length === 0 || !el.trim();
  }, false);
};

//checks that string input is not empty and less than or equal to limit
export const isWithinBounds = (str, upperBoundLimit, lowerBoundLimit = 0) => {
  return str
    ? str.length > lowerBoundLimit && str.length <= upperBoundLimit
    : false;
};

export const isAlphanumeric = (str) => {
  let re = RegExp(/^[a-z0-9]+$/i);
  return re.test(str);
};

export const isValidWidth = (str) => {
  return str && str.length > 0
    ? str.length > 2 &&
        str.slice(-2).toLowerCase() === "px" &&
        !isNaN(str.slice(0, -2))
    : true;
};

export const setInputValue = (e) =>
  e.hasOwnProperty("target")
    ? e.target.value
    : e.hasOwnProperty("value")
    ? e.value
    : e;

export const isValidEmail = (str) => {
  if (typeof str !== "string") {
    throw new TypeError("Invalid type, value must be string");
  }
  return !!str.match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
};

// allows only whole numbers 0-100
export const isValidPercentage = (value) => {
  let num = parseFloat(value);
  if (typeof num !== "number") {
    throw new TypeError("Invalid type, value must be number");
  }
  return num % 1 === 0 && num >= 0 && num <= 100;
};
